export default {
  customization: state => state.customization
}
